import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const original = this.element.innerHTML
    const confirm = () => {
      this.element.textContent = "Copied!"
      setTimeout(() => { this.element.innerHTML = original }, 1500)
    }

    // Native iOS: use WKScriptMessageHandler (works in WKWebView without HTTPS)
    if (window.webkit?.messageHandlers?.nativeClipboard) {
      window.webkit.messageHandlers.nativeClipboard.postMessage(this.textValue)
      confirm()
      return
    }

    // Browser: use Clipboard API with execCommand fallback
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.textValue).then(confirm).catch(() => this._fallbackCopy(confirm))
    } else {
      this._fallbackCopy(confirm)
    }
  }

  _fallbackCopy(callback) {
    const el = document.createElement("textarea")
    el.value = this.textValue
    el.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;"
    document.body.appendChild(el)
    el.focus()
    el.select()
    try {
      document.execCommand("copy")
      callback()
    } catch (e) {}
    document.body.removeChild(el)
  }
}
